export default "__VITE_ASSET__Cwinrjrm__"